export const environment = {
  isProduction: true,
  store: 'https://staging.paratype.net',
  host: 'https://api-staging.paratype.net',
  azureBlobCdnHost: 'https://ptdt.azureedge.net/',
  identity: {
    host: 'https://identity-staging.paratype.net',
    clientId: 'angular_web_store',
    scope: 'email roles api offline_access'
  }
};
